// ── iqUtils.js ───────────────────────────────────────────────────────────────

// export function calcIQ(correct, total, avgSpeed) {
//   const base = 80;
//   const accuracy = correct / total;
//   const speedFactor = avgSpeed != null ? Math.max(0, 1 - avgSpeed / 20) : 0;
//   return Math.round(base + accuracy * 60 + speedFactor * 20);
// }

export function calcIQ(correct = 0, total = 10, avgSpeed = 20) {
  if (!total) total = 10;
  if (Number.isNaN(avgSpeed)) avgSpeed = 20;

  const accuracy = correct / total;

  // IQ depends mostly on accuracy
  let iq = 70 + accuracy * 80;

  // Speed bonus only if at least half answers are correct
  if (correct >= Math.ceil(total / 2)) {
    const speedBonus = Math.max(0, 1 - avgSpeed / 20) * 10;
    iq += speedBonus;
  }

  return Math.round(iq);
}

export function iqTier(iq) {
  if (iq >= 145) return { label: 'Certified Genius 🤯', color: '#A78BFA' };
  if (iq >= 135) return { label: 'Big Brain Energy 🧠', color: '#818CF8' };
  if (iq >= 125) return { label: 'Lowkey a Genius ✨', color: '#34D399' };
  if (iq >= 115) return { label: 'Above Average Slayer 💅', color: '#06B6D4' };
  if (iq >= 105) return { label: "You're Doing Great 💪", color: '#FBBF24' };
  if (iq >= 95)  return { label: 'Mid But Iconic 😌', color: '#F472B6' };
  return { label: 'L + Touch Grass 🌱', color: '#9CA3AF' };
}

export function calcStreakBonus(days) {
  if (days >= 30) return 500;
  if (days >= 14) return 200;
  if (days >= 7)  return 100;
  if (days >= 3)  return 30;
  return 10;
}